"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
var ButtonGroup_1 = require("../ButtonGroup");
var Button_1 = require("../Button");
var ButtonDropdownFooter = function (props) {
    var _a = props.onApply, onApply = _a === void 0 ? noop_1.default : _a, _b = props.onCancel, onCancel = _b === void 0 ? noop_1.default : _b, _c = props.disableOnApply, disableOnApply = _c === void 0 ? false : _c, _d = props.secondary, secondary = _d === void 0 ? false : _d;
    var className = 'button-dropdown-footer';
    return secondary ? (react_1.default.createElement(StyledContainer, { className: className },
        react_1.default.createElement(ButtonGroup_1.ButtonGroup, null,
            react_1.default.createElement(Button_1.Button, { buttonStyle: "SECONDARY", icon: "add_circle", onClick: onApply, disabled: disableOnApply }, "Add")))) : (react_1.default.createElement(StyledContainer, { className: className },
        react_1.default.createElement(ButtonGroup_1.ButtonGroup, null,
            react_1.default.createElement(Button_1.Button, { buttonStyle: "SECONDARY", onClick: onCancel }, "Cancel"),
            react_1.default.createElement(Button_1.Button, { buttonStyle: "PRIMARY", onClick: onApply, disabled: disableOnApply }, "Apply"))));
};
exports.default = ButtonDropdownFooter;
var StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  text-align: right;\n  padding: 1.6rem;\n  background-color: ", ";\n  border-top: ", ";\n"], ["\n  width: 100%;\n  text-align: right;\n  padding: 1.6rem;\n  background-color: ", ";\n  border-top: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[0];
}, function (_a) {
    var theme = _a.theme;
    return "1px solid " + theme.colors.NTDarkGrey[200];
});
var templateObject_1;
